import { Box } from '@material-ui/core';
import { FieldValues } from 'react-hook-form';

import { CustomFormLabelWithAdornment } from '@/components/shared/components/NewContextForms/shared/CustomFormLabelWithAdornment';
import { CustomTextFieldProps } from '@/components/shared/components/NewContextForms/shared/CustomTextField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

import { CustomDivider } from '../../CustomDivider';
import { Font } from '../../Font';

export interface ReadOnlyDataRowProps<TFieldValues extends FieldValues> extends CustomTextFieldProps<TFieldValues> {}

export function ReadOnlyDataRow<TFieldValues extends FieldValues>({
  label,
  labelDynamicDataTexts,
  strongTitle,
  valueUnit,
  labelIcon,
  labelIconPosition = 'end',
  valueStartIcon,
  tooltipTitle,
  underlined = true,
  forceSingleLine = false,
  wrap = false,
  disableTranslation = false,
  boxProps,
  ...props
}: ReadOnlyDataRowProps<TFieldValues>) {
  const { hasTranslation, getTextIdTranslation } = useTranslation();
  const value = props.value as string | number;

  return (
    <>
      <Box
        display={'flex'}
        flexDirection={'column'}
        width="100%"
        minWidth={0}
        mt={props.fieldVariant === FieldVariant.form ? '25px' : 0}
        {...boxProps}
      >
        <Box
          py={underlined ? 1 : '2px'}
          flexGrow={1}
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={forceSingleLine ? 'end' : 'baseline'}
          width="100%"
          minWidth={0}
          overflow="hidden"
        >
          {label && (
            <Box flex="1 1 0" minWidth={0} overflow="hidden" pr={1}>
              <CustomFormLabelWithAdornment
                useInputAdornment={false}
                value={value}
                tooltipTitle={tooltipTitle}
                labelIcon={labelIcon}
                label={label}
                labelIconPosition={labelIconPosition}
                labelDynamicDataTexts={labelDynamicDataTexts}
                strongTitle={strongTitle}
                labelSuffix={props.labelSuffix}
                copyButton={props.copyToClipboard}
              />
            </Box>
          )}
          <Font
            className={`${wrap ? 'wrap-text' : ''}`}
            variant="h5"
            color="textPrimary"
            style={{
              textAlign: 'right',
              paddingLeft: '8px',
              flex: '0 0 auto',
              flexShrink: 0,
              minWidth: 0,
              maxWidth: '50%',
              overflowWrap: 'break-word',
            }}
          >
            {valueStartIcon}{' '}
            {value || value === 0
              ? hasTranslation(value) && !disableTranslation
                ? getTextIdTranslation(value)
                : value
              : '-'}{' '}
            {valueUnit}
          </Font>
        </Box>
        {underlined && <CustomDivider orientation={'horizontal'} margin={0} />}
      </Box>
    </>
  );
}
